/** @format */

import React, { Component } from 'react';
import { Segment, Header, Table, Icon } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientFiscal extends Component {
  renderContent = content => {
    if (content !== null && content !== undefined && content !== '') {
      return content;
    } else {
      return '-';
    }
  };
  render() {
    const { ClientsStore } = this.props;
    const currentClient = ClientsStore.currentClient;
    return (
      <Segment className="reqPart-box headed-segment" padded>
        <div className="segment-header smaller">
          <Header as="h4">
            <small>
              <Icon name="id card" />
            </small>
            Dati Fiscali
          </Header>
        </div>
        <Table compact basic="very" fixed celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>
                    <Icon name="vcard" /> Codice Fiscale
                  </strong>
                </small>
                <br />
                {this.renderContent(currentClient.data.fiscalCode)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>
                    <Icon name="factory" /> P.Iva
                  </strong>
                </small>
                <br />
                {this.renderContent(currentClient.data.vatNumber)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default ClientFiscal;
